export function requireMediaDevices(): MediaDevices {
  if (typeof navigator === 'undefined' || !navigator.mediaDevices) {
    throw new Error('RTC media APIs are only available in a supported browser');
  }
  return navigator.mediaDevices;
}

export function toError(error: unknown, fallback = 'Unknown RTC error'): Error {
  if (error instanceof Error) return error;
  if (typeof error === 'string' && error) return new Error(error);
  return new Error(fallback);
}
